<div class="privacy-policy">
  <h1>Privacy Policy</h1>
  <p><strong>Effective Date:</strong> 15 March 2025</p>

  <h2>1. Introduction</h2>
  <p>
    Versus: Fitness Challenges ("we," "our," "us") is committed to protecting
    your privacy. This Privacy Policy explains how we collect, use, disclose,
    and safeguard your information when you use our mobile application (the
    "App"). By using the App, you agree to the collection and use of information
    as described in this policy.
  </p>

  <h2>2. Information We Collect</h2>
  <p>
    We collect different types of information to provide and improve our
    services:
  </p>

  <h3>a. Account Information</h3>
  <ul>
    <li>
      When you create an account, we collect your email address and password. If
      you sign in using Google or Apple ID, we receive basic profile information
      from those providers.
    </li>
    <li>
      We do not have access to or store your password in plain text. Passwords
      are securely encrypted and cannot be read by us.
    </li>
  </ul>

  <h3>b. Health and Fitness Data</h3>
  <ul>
    <li>
      To participate in fitness challenges, we may request permission to access
      health-related data from your device, including:
      <ul>
        <li>Steps count</li>
        <li>Distance traveled</li>
        <li>Calories burned</li>
      </ul>
    </li>
    <li>
      This data is only accessed when you join a challenge requiring such
      information. You may revoke access at any time through your device
      settings.
    </li>
  </ul>

  <h3>c. Usage and Device Information</h3>
  <ul>
    <li>
      We may collect information about your interactions with the App, including
      device type, operating system, and app usage analytics.
    </li>
  </ul>

  <h2>3. How We Use Your Information</h2>
  <ul>
    <li>Provide and improve the App’s functionality</li>
    <li>Facilitate fitness challenges and track progress</li>
    <li>Personalize user experience</li>
    <li>Communicate with users regarding updates and support</li>
    <li>Ensure compliance with legal requirements</li>
  </ul>

  <h2>4. Sharing and Disclosure of Information</h2>
  <p>
    We do not sell or rent your personal data. However, we may share information
    in the following situations:
  </p>
  <ul>
    <li>
      With service providers who assist in app functionality and analytics
    </li>
    <li>
      If required by law or to protect the rights and safety of users and our
      platform
    </li>
    <li>With your explicit consent</li>
  </ul>

  <h2>5. Data Security</h2>
  <p>
    We implement security measures to protect your data from unauthorized
    access, alteration, disclosure, or destruction. However, no system is
    completely secure, and we cannot guarantee absolute security.
  </p>

  <h2>6. Your Rights and Choices</h2>
  <ul>
    <li>Managing permissions for health data through your device settings</li>
    <li>Editing or deleting your account information</li>
    <li>
      Contacting us to request access, correction, or deletion of your data
    </li>
  </ul>

  <h2>7. Third-Party Services</h2>
  <p>
    Our App may contain links to third-party services. We are not responsible
    for the privacy practices of these external platforms.
  </p>

  <h2>8. Children's Privacy</h2>
  <p>
    Our App is not intended for users under the age of 13. If we become aware
    that we have collected information from a child, we will take steps to
    delete it.
  </p>

  <h2>9. Changes to This Privacy Policy</h2>
  <p>
    We may update this Privacy Policy from time to time. Any changes will be
    posted in the App with an updated effective date.
  </p>

  <h2>10. Contact Us</h2>
  <p>
    If you have any questions about this Privacy Policy, please contact us at:
    <br />
    <a href="mailto:contact@versus-studios.com"
      >contact&#64;versus-studios.com</a
    >
    ><br />
    Versus Studios<br />
    Stafettgatan 3A, Gothenburg, Sweden
  </p>
</div>
